import { startApp } from './starter'
startApp()
